export const metalsWithCode = [
  { code: 'Au', name: 'Gold' },
  { code: 'Ag', name: 'Silver' },
  { code: 'Pt', name: 'Platinum' },
  { code: 'Pd', name: 'Palladium' },
];


export const indianStates = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
];

export const faqs = [
  {
    question: "What is eBullion?",
    answer: "eBullion is a digital platform to buy gold and silver online."
  },
  {
    question: "Is my gold safe?",
    answer: "Yes, it is stored in a fully insured vault."
  },
  {
    question: "Can I sell anytime?",
    answer: "Yes, you can sell anytime at live market rates."
  },
  {
    question: "Is there any hidden fee?",
    answer: "No, there are no hidden charges."
  }
];